<template>
  <div class="m-segment">
    <div class="m-segment-title">
       <BaseIcon :icon="icon" v-if="icon" :size="18" class="m-segment-icon" />
      <div class="flex-wrap">

          <div :style="icon?'margin-left:25px':''">

            <slot name="title"></slot>
            <template v-if="!$slots.title">
              <span v-if="required" style="color:red;margin-right:5px">*</span>{{title}}
            </template>
            <div class="m-segment-sub" v-if="desc">{{desc}}</div>
          </div>
          <slot name="title-append"></slot>
        </div>
        <div class="flex-wrap">
          <template v-if="!collapse">
          <slot name="extra"></slot>
          </template>
          <BaseIcon  v-if="disbaled !== undefined && !disabled" :icon="!collapse?'md-remove':'ios-arrow-down'" style="cursor:pointer;margin-right:5px;margin-left:10px;border:1px solid var(--border);border-radius:5px;padding:5px;box-shadow:1px 1px 1px var(--border);" @click="collapse = !collapse" />
        </div>
      </div>
    <div class="m-segment-content" :class="{'m-segment-content-collapsed':collapse}">
    <slot></slot>
    </div>
    <template v-if="collapse">
    <slot name="shrink"></slot>
    </template>
  </div>
</template>

<script>
export default {
  props: ['title', 'desc', 'icon', 'disbaled', 'required'],
  data() {
    return {
      collapse: false,
    };
  },
  methods: {
    fold() {
      this.collapse = true;
    },
    unfold() {
      this.collapse = false;
    },
  },
};
</script>

<style lang="less">
.m-segment{
  margin-bottom:20px;
  box-shadow: 1px 1px 2px 1px var(--border);
  background:var(--bg3);
  border-radius: 5px;
  border:1px solid var(--border);

  .m-segment-icon{
    margin-right:10px;padding:5px;background:var(--primary);color:#fff;
    box-shadow:0 1px 2px 1px var(--border);position:absolute;left:0;border-top-right-radius:5px;border-bottom-right-radius:5px;
  }
  .m-segment-title{
    font-size:16px;
    font-weight: bold;
    color:var(--text2);
    position: relative;
    padding:10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom:1px solid var(--border);
    padding-left:15px;
    overflow: hidden;
  }

  .m-segment-sub{
    font-size:12px;
    font-weight: normal;
    color:var(--subtext3);
  }

  .m-segment-title:before{
  position: absolute;
  content:" ";
  width:4px;
  height:20px;
  left:0px;
  top:calc(50% - 10px);
  background:var(--primary);
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

  .m-segment-content{
    overflow: hidden;
    transition:all 0.3s;
    font-size:14px;
    padding:20px;
    position: relative;
    width:100%;
  }

  .m-segment-content-collapsed{
    max-height:0;
    padding:0;
  }
}
</style>
